var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-stripe" },
    [
      _vm.permissionIsEnabled("settings.force_cvv:view")
        ? _c(
            "cvv",
            {
              attrs: {
                title: _vm.$t("account.settings.cvv.title"),
                callback: _vm.saveForceCvv,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.forceCvv.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.force_cvv:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.forceCvv,
                    _vm.recurrenceSettings.forceCvv
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("account.settings.cvv.config")) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("account.settings.cvv.config-detail")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "enableForceCvv" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("account.settings.cvv.status"))
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableForceCvv" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.forceCvv.force_cvv,
                                  expression: "forceCvv.force_cvv",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: { type: "checkbox", id: "enableForceCvv" },
                              domProps: {
                                checked: Array.isArray(_vm.forceCvv.force_cvv)
                                  ? _vm._i(_vm.forceCvv.force_cvv, null) > -1
                                  : _vm.forceCvv.force_cvv,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.forceCvv.force_cvv,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.forceCvv,
                                          "force_cvv",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.forceCvv,
                                          "force_cvv",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.forceCvv, "force_cvv", $$c)
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(_vm.$t("account.settings.cvv.active"))
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.subscriptions:view")
        ? _c(
            "subscriptions",
            {
              attrs: {
                title: _vm.$t("account.settings.subscriptions.title"),
                callback: _vm.saveSubscriptionsSettings,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.subscriptions.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.subscriptions:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.subscriptions,
                    _vm.recurrenceSettings.subscriptions
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscriptions.config"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "status" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("account.settings.subscriptions.status")
                              )
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableSubscriptions" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.subscriptions.enabled,
                                  expression: "subscriptions.enabled",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: {
                                type: "checkbox",
                                id: "enableSubscriptions",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.subscriptions.enabled
                                )
                                  ? _vm._i(_vm.subscriptions.enabled, null) > -1
                                  : _vm.subscriptions.enabled,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.subscriptions.enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.subscriptions,
                                          "enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.subscriptions,
                                          "enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.subscriptions, "enabled", $$c)
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscriptions.active"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscriptions.due-days-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c(
                        "div",
                        { staticClass: "emd-form-group _condensed_30" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              attrs: { for: "status" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscriptions.due-days"
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.subscriptions.boleto_due_days,
                                expression: "subscriptions.boleto_due_days",
                              },
                            ],
                            staticClass: "emd-input",
                            attrs: {
                              id: "dueDays",
                              type: "text",
                              placeholder: _vm.$t(
                                "account.settings.subscriptions.due-days-placeholder"
                              ),
                            },
                            domProps: {
                              value: _vm.subscriptions.boleto_due_days,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.subscriptions,
                                  "boleto_due_days",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.attempts:search")
        ? _c(
            "subscription-attempt",
            {
              attrs: {
                title: _vm.$t("account.settings.subscription-attempt.title"),
                callback: _vm.saveSubscriptionAttemptSettings,
                loading: _vm.attemptLoading,
                formIsInvalid: _vm.$v.subscriptionAttempt.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.subscription_attempt:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.subscriptionAttempt,
                    _vm.attemptSettings
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscription-attempt.config"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscription-attempt.status-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "status" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "account.settings.subscription-attempt.status"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableSubscriptionAttempt" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.subscriptionAttempt.status,
                                  expression: "subscriptionAttempt.status",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: {
                                type: "checkbox",
                                id: "enableSubscriptionAttempt",
                                "true-value": "active",
                                "false-value": "inactive",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.subscriptionAttempt.status
                                )
                                  ? _vm._i(
                                      _vm.subscriptionAttempt.status,
                                      null
                                    ) > -1
                                  : _vm._q(
                                      _vm.subscriptionAttempt.status,
                                      "active"
                                    ),
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.subscriptionAttempt.status,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? "active" : "inactive"
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.subscriptionAttempt,
                                          "status",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.subscriptionAttempt,
                                          "status",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.subscriptionAttempt,
                                      "status",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscription-attempt.active"
                                  )
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscription-attempt.intervals"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscription-attempt.intervals-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c(
                        "div",
                        { staticClass: "emd-form-group _condensed_50" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "emd-label",
                              class: {
                                _required:
                                  _vm.subscriptionAttempt.status === "active",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.subscription-attempt.interval-number"
                                  )
                                )
                              ),
                            ]
                          ),
                          _vm.attemptIntervals.length > 0
                            ? _c(
                                "ul",
                                { staticClass: "emd-list _space_base" },
                                [
                                  _vm._l(
                                    _vm.attemptIntervals,
                                    function (interval, index) {
                                      return _c("li", { key: index }, [
                                        _c(
                                          "div",
                                          { staticClass: "emd-input-group" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: interval.value,
                                                  expression: "interval.value",
                                                },
                                              ],
                                              staticClass: "emd-input",
                                              class: {
                                                _state_error:
                                                  _vm.sumOfAttempts > 7200,
                                              },
                                              attrs: {
                                                type: "number",
                                                name: "interval[]",
                                                max: _vm.maxAttempt,
                                              },
                                              domProps: {
                                                value: interval.value,
                                              },
                                              on: {
                                                input: [
                                                  function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      interval,
                                                      "value",
                                                      $event.target.value
                                                    )
                                                  },
                                                  function ($event) {
                                                    return _vm.validateInterval(
                                                      index,
                                                      interval.value
                                                    )
                                                  },
                                                ],
                                              },
                                            }),
                                            index !== 0 ||
                                            (index === 0 &&
                                              _vm.attemptIntervals.length > 1)
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "emd-btn _color_danger _type_text",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeInterval(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "uil uil-minus-circle",
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ])
                                    }
                                  ),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "emd-btn _color_primary",
                                      attrs: {
                                        type: "button",
                                        disabled:
                                          _vm.attemptIntervals.length > 5 ||
                                          !_vm.attemptIntervals[
                                            _vm.attemptIntervals.length - 1
                                          ].value ||
                                          _vm.attemptIntervals[
                                            _vm.attemptIntervals.length - 1
                                          ].value < 1,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addInterval()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "uil uil-plus" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "account.settings.subscription-attempt.add-retry"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.permissionIsEnabled("settings.card_updater:view")
        ? _c(
            "card-updater",
            {
              attrs: {
                title: _vm.$t("account.settings.card-updater.title"),
                callback: _vm.saveCardUpdaterSettings,
                loading: _vm.accountLoading,
                formIsInvalid: _vm.$v.cardUpdater.$invalid,
                hideEditButton: !_vm.permissionIsEnabled(
                  "settings.card_updater:edit"
                ),
              },
              on: {
                cancelEdit: function ($event) {
                  return _vm.resetObject(
                    _vm.cardUpdater,
                    _vm.recurrenceSettings.cardUpdater
                  )
                },
              },
            },
            [
              _c("template", { slot: "content" }, [
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.card-updater.manual-renovation"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.card-updater.manual-renovation-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "status" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("account.settings.card-updater.status")
                              )
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableManual" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cardUpdater.manual_renew_enabled,
                                  expression:
                                    "cardUpdater.manual_renew_enabled",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: { type: "checkbox", id: "enableManual" },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.cardUpdater.manual_renew_enabled
                                )
                                  ? _vm._i(
                                      _vm.cardUpdater.manual_renew_enabled,
                                      null
                                    ) > -1
                                  : _vm.cardUpdater.manual_renew_enabled,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.cardUpdater.manual_renew_enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.cardUpdater,
                                          "manual_renew_enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.cardUpdater,
                                          "manual_renew_enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.cardUpdater,
                                      "manual_renew_enabled",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.card-updater.active")
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "emd-panel" }, [
                  _c("div", { staticClass: "emd-panel__section" }, [
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "h2",
                          {
                            staticClass:
                              "emd-text _color_default _type_caption",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.card-updater.automatic-renovation"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "el-chunk" }, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "emd-text _color_nonessential _size_small",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "account.settings.card-updater.automatic-renovation-detail"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "emd-panel__block" }, [
                      _c("div", { staticClass: "emd-form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "emd-label",
                            attrs: { for: "status" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("account.settings.card-updater.status")
                              )
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "emd-input-helper" }),
                        _c(
                          "label",
                          {
                            staticClass: "emd-switcher__label",
                            attrs: { for: "enableAutomatic" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.cardUpdater.renew_on_payment_enabled,
                                  expression:
                                    "cardUpdater.renew_on_payment_enabled",
                                },
                              ],
                              staticClass: "emd-switcher _color_success",
                              attrs: {
                                type: "checkbox",
                                id: "enableAutomatic",
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.cardUpdater.renew_on_payment_enabled
                                )
                                  ? _vm._i(
                                      _vm.cardUpdater.renew_on_payment_enabled,
                                      null
                                    ) > -1
                                  : _vm.cardUpdater.renew_on_payment_enabled,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a =
                                      _vm.cardUpdater.renew_on_payment_enabled,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.cardUpdater,
                                          "renew_on_payment_enabled",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.cardUpdater,
                                          "renew_on_payment_enabled",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.cardUpdater,
                                      "renew_on_payment_enabled",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("div", { staticClass: "emd-switcher__area" }),
                            _c("span", { staticClass: "emd-switcher__text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("account.settings.card-updater.active")
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }